export const queryKeys = {
  USE_SAVED_TESTS: 'use-saved-tests'
};
